<template>
    <Modal @cancel="cancel">
        <ModalCard
            @cancel="cancel"
            :headerTitle="$t('modale.options.suivi.di.title')"
            :withoutBotNav="true"
            :active-validate="false"
            id="loadingdiv"
        >
            <div :class="{ disabled: !suiviActif }">
                <div class="check-ligne" v-if="!isLoading">
                    <CheckBox :checked="suiviActif" :label="$t('modale.options.suivi.di.enable')" @click-check="toggleSuivi"/>
                    <ReglePastille cle="optionsInterventions.desactivationGlobale" />
                </div>
                <content-loader v-else :width="width" :height="listHeight">
                    <rect x="0" y="0" rx="3" ry="3" :width="width/2" height="15" />
                    <rect x="0" y="35" rx="3" ry="3" :width="width" height="40" />
                </content-loader>
                <div class="mails" v-if="!isLoading">
                    <div class="line" v-for="email in emailsSuivi" :key="email.id">
                        <CheckBox :checked="email.actif" :label="email.email" @click-check="toggleEmailActif(email)" :disabled="!suiviActif || (!email.actif && emailInputDisabled)" />
                        <img class="trash-icon" :class="{ disabled: !suiviActif, enabled: suiviActif}" :src="deleteIcon" alt="delete" @click="deleteEmail(email)"/>
                    </div>
                </div>
                <div class="add">
                    <TextInput class="input" v-model="newEmail" :label="inputLabel" :disabled="emailInputDisabled"/>
                    <ButtonBlue :text="$t('modale.options.suivi.di.add.button')" :on-click="addEmail" :disabled="emailButtonDisabled"></ButtonBlue>
                    <ReglePastille cle="optionsInterventions.formatEmail" />
                    <ReglePastille cle="optionsInterventions.maxEmails" />
                </div>
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import { OPTIONS_SUIVI } from '@/modules/OptionsSuiviInterventions/store/mutation-types';
import CheckBox from '@/components/ui-components/CheckBox.vue';
import { store } from '@/plugins/store';
import { OptionsSuiviDIModuleAction } from '@/modules/OptionsSuiviInterventions/store/actions-types';
import { EmailSuivi } from '@/modules/OptionsSuiviInterventions/store/state';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import { ContentLoader } from 'vue-content-loader';
import TextInput from '@/components/ui-components/TextInput.vue';
import i18n from '@/plugins/i18n';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'OptionSuiviModale',
    components: { CheckBox, Modal, ModalCard, ButtonBlue, TextInput, ContentLoader, ReglePastille },
    beforeMount() {
        store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.GET_SUIVI_DI}`);
    },
    mounted() {
        const loadingElement: typeof HTMLElement | any = document.getElementById('loadingdiv');
        this.width = loadingElement.offsetWidth-48;
    },
    data() {
        return {
            width: 0,
        };
    },
    methods: {
        cancel() {
            store.commit(`optionsSuiviInterventionState/${OPTIONS_SUIVI.SET_MODAL}`, false);
        },
        toggleSuivi() {
            if(this.suiviActif){
                store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.DESACTIVER_SUIVI_DI}`);
            } else {
                store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.ACTIVER_SUIVI_DI}`);
            }
        },
        toggleEmailActif(email: EmailSuivi) {
            if(email.actif){
                store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.DESACTIVER_EMAIL_SUIVI}`, email);
            } else {
                store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.ACTIVER_EMAIL_SUIVI}`, email);
            }
        },
        deleteEmail(email: EmailSuivi){
            store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.SUPPRIMER_EMAIL_SUIVI}`, email);
        },
        addEmail(){
            if(!store.getters['optionsSuiviInterventionState/isMaximumEmailActifReached']){
                store.dispatch(`optionsSuiviInterventionState/${OptionsSuiviDIModuleAction.AJOUTER_EMAIL_SUIVI}`);
            }
        },
    },
    computed:{
        store() {
            return store;
        },
        closeIcon(){
            return require('@/assets/img/close-black.svg');
        },
        suiviActif(): boolean {
            return store.getters['optionsSuiviInterventionState/isSuiviActif'];
        },
        emailsSuivi(): EmailSuivi[] {
            return store.getters['optionsSuiviInterventionState/emailsSuivi'];
        },
        deleteIcon() {
            return require('@/assets/img/delete.svg');
        },
        isLoading(){
            return store.state.optionsSuiviInterventionState.isLoading;
        },
        emailButtonDisabled(): boolean {
            return this.isLoading || !this.suiviActif || store.getters['optionsSuiviInterventionState/isMaximumEmailActifReached'] || !/\S+@\S+\.\S+/.test(this.newEmail);
        },
        emailInputDisabled(): boolean {
            return this.isLoading || !this.suiviActif || store.getters['optionsSuiviInterventionState/isMaximumEmailActifReached'];
        },
        listHeight(): number {
            const nbLignes = this.emailsSuivi?.length;
            return (nbLignes*34)+(nbLignes*6)+(nbLignes-1)+35;
        },
        newEmail: {
            get(){
                return store.state.optionsSuiviInterventionState.newEmail;
            },
            set(email: string){
                store.commit(`optionsSuiviInterventionState/${OPTIONS_SUIVI.SET_EMAIL}`, email);
            }
        },
        inputLabel(){
            return store.getters['optionsSuiviInterventionState/isMaximumEmailActifReached'] ? i18n.global.t('modale.options.suivi.di.add.placeholder.disabled') : i18n.global.t('modale.options.suivi.di.add.placeholder.active');
        }
    },
});
</script>

<style scoped>
.mails {
    margin-top: 20px;
}
.check-ligne {
    display: flex;
    align-items: center;
}
:deep(.checkmark) {
    margin-top: -2px;
}
:deep(.card-container){
    width: 45vw;
}
.line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    outline: 1px solid var(--color-principal);
    margin-top: 1px;
    padding: 3px 3px 3px 20px;
    height: 34px;
}
.line:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}
.line:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}
.trash-icon {
    margin-right: 10px;
}
.add {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}
.input {
    width: 60%;
    margin-top: 0;
    margin-right: 10px;
}
:deep(.text-input) {
    font-size: 16px;
}
:deep(button){
    height: 40px;
    width: 90px;
    border-radius: 5px;
    cursor: pointer;
}
.enabled {
    cursor: pointer;
}
</style>
